/**
 * Initialize sidebar from provided config.
 * Sets active state based on current URL path or controller path.
 *
 * Items can use either:
 * - `activeUrl` — matches against window.location.pathname (preferred, URL-based)
 * - `activeExact` — when true, activeUrl uses exact match instead of startsWith
 * - `activePath` — matches against store.currentPath (legacy, controller-based)
 *
 * @param {Object} store - Global store instance
 * @param {Object} config - Sidebar config with items array
 */
export default function initSidebar(store, config) {
  if (!config) return

  const currentUrl = window.location.pathname

  const filtered = config.items.filter((item) => !item.show || item.show(store))

  // When several items match the current URL/path, pick the most specific one
  // (longest activeUrl/activePath). Otherwise on /scan_sessions/new both
  // "New Scan" and "All Sessions" would match and the order in the config wins.
  let bestIdx = -1
  let bestLen = -1
  filtered.forEach((item, idx) => {
    if (!isItemActive(currentUrl, store.currentPath, item)) return
    const len = (item.activeUrl || item.activePath || '').length
    if (len > bestLen) {
      bestLen = len
      bestIdx = idx
    }
  })

  store.sidebar = {
    compact: Boolean(config.compact),
    items: filtered.map((item, idx) => ({
      ...item,
      active: idx === bestIdx
    }))
  }
}

function isItemActive(currentUrl, currentPath, item) {
  if (item.activeUrl) {
    return item.activeExact ?
      currentUrl === item.activeUrl :
      currentUrl.startsWith(item.activeUrl)
  }

  if (item.activePath && currentPath) {
    return currentPath.startsWith(item.activePath)
  }

  return false
}
